(function (angular) {
  /**
   * Service: customersApi
   */
  angular
    .module('acme.common.service.customersApi', [
      'acme.common.factory.apiVersion',
      'acme.common.factory.QueryStringBuilder',
    ])
    .service('CustomersApiService', CustomersApiService);

  CustomersApiService.$inject = ['$http', 'QueryStringBuilderFactory', 'ApiVersionFactory'];

  function CustomersApiService($http, QueryStringBuilderFactory, ApiVersionFactory) {
    return {
      service: '',

      init: function (endpoint) {
        this.service = endpoint + '/customers';
        return true;
      },

      list: function (props) {
        var q = '';
        var av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'search', 'sortField', 'sortDirection', 'startDate', 'endDate'],
            },
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service, version: 'v2' }) + q,
        });
      },

      advancedSearch: function (props) {
        var q = '';
        var av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: [
                'pageSize',
                'page',
                'search',
                'sortField',
                'sortDirection',
                'startDate',
                'endDate',
                'firstName',
                'lastName',
                'address',
                'zip',
                'email',
                'customerId',
              ],
            },
          });

          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/advancedsearch' + q, version: 'v2' }),
        });
      },

      detail: function (props) {
        var q = '',
          av = new ApiVersionFactory(),
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['includeAssociatedMemberships', 'includeMergeHistory'],
            },
          });

        q = qs.query;

        return $http({
          method: 'get',
          url: av.init({ url: this.service, version: 'v2' }) + '/' + props.customerId + q,
        });
      },

      /**
       * @example
       * /v2/b2b/customers
       * {
       *   "firstName": "Michele",
       *   "lastName": "Clarke",
       *   "solicitationCodes": [],
       *   "email": "michele@acmeticketing.com",
       *   "customerId": "ACS292473398",
       *   "phoneNumber": "6505555555",
       *   "externalCustomerImportId": "ACMEACS292473398",
       *   "address": [{
       *     "id": 19290743,
       *     "country": "United States",
       *     "isPrimary": true,
       *     "type": "primary"
       *   }],
       *   "attributes": [],
       *   "middleName": "",
       *   "id": 2353948,
       *   "customerSource": "acme",
       *   "notes": "Super awesome supporter"
       * }
       *
       * Note: omitting `notes` preserves the existing value; passing an empty string clears it.
       *
       * @param {object} props
       * @returns {Promise}
       */
      update: function (props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url: av.init({ url: this.service, version: 'v2' }),
          data: {
            prefix: props.prefix,
            firstName: props.firstName,
            lastName: props.lastName,
            solicitationCodes: props.solicitationCodes,
            email: props.email,
            customerId: props.customerId,
            phoneNumber: props.phoneNumber,
            orgName: props.orgName,
            externalCustomerImportId: props.externalCustomerImportId,
            address: props.address,
            attributes: props.attributes,
            middleName: props.middleName,
            id: props.id,
            customerSource: props.customerSource,
            notes: props.notes,
          },
        });
      },

      /**
       * @param {{ baseId: string; duplicateIds: string[] }} props
       */
      merge: function (props) {
        return $http({
          method: 'post',
          url: '/v2/api/merge/customers',
          data: {
            baseId: props.baseId,
            duplicateIds: props.duplicateIds,
          },
        });
      },
    };
  }
})(window.angular);
